export default __webpack_public_path__ + "static/media/promise.333c8dd7.jpg";